<template>
  <el-table
    :data="tableData"
    :span-method="spanMethod"
    :header-cell-style="discountHeaderStyle"
    :cell-style="setSellStyle"
    :summary-method="getSummaries"
    :highlight-current-row="false"
    show-summary
    style="width: 100%; margin-top: 20px"
  >
    <el-table-column :label="$t('hsk_test_content')">
      <el-table-column
        :label="$t('hsk_test_content')"
        prop="segmentCode"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <div class="segment-cell">
            <img
              class="segment_img"
              :class="{ segment_img_listen: scope.row.segmentCodePart === 'listen' }"
              :src="require(`@/assets/images/hsk/${scope.row.segmentCodePart}.png`)"
              alt=""
            />
            <span class="segment-cell-text">{{ scope.row.segmentCode }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('hsk_test_content')"
        prop="partCode"
        header-align="center"
        align="center"
        width="120"
      >
      </el-table-column>
      <el-table-column
        :label="$t('hsk_test_content')"
        prop="segmentDesc"
        header-align="center"
        align="center"
        width="200"
      >
      </el-table-column>
    </el-table-column>
    <el-table-column :label="$t('hsk_test_num')" header-align="center" align="center">
      <el-table-column
        prop="objectiveQuestionCount"
        header-align="center"
        align="center"
        :label="$t('hsk_introduce_objective_questions')"
        width="100"
      >
        <template slot-scope="scope">
          <div class="segment-cell">
            {{ scope.row.objectiveQuestionCount ? scope.row.objectiveQuestionCount : '——' }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="subjectiveQuestionCount"
        header-align="center"
        align="center"
        :label="$t('hsk_introduce_subjective_questions')"
        width="100"
      >
        <template slot-scope="scope">
          <div class="segment-cell">
            {{ scope.row.subjectiveQuestionCount ? scope.row.subjectiveQuestionCount : '——' }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="questionCountMoudleTotal"
        :label="$t('total')"
        header-align="center"
        align="center"
        width="100"
      >
      </el-table-column>
    </el-table-column>
    <el-table-column
      prop="duration"
      :label="$t('hsk_test_time')"
      header-align="center"
      align="center"
    >
      <template slot-scope="scope">
        <div class="segment-cell">
          <img class="segment_img_time" :src="require(`@/assets/images/hsk/time1.png`)" alt="" />
          <span class="segment-cell-text">{{ scope.row.duration }}</span>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    setSellStyle: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {}
  },
  methods: {
    getSpan(list) {
      const newArr = []
      const obj = {}
      for (let i = 0; i < list.length; i++) {
        if (i === 0) {
          obj.row = 1
          obj.col = 1
          newArr.push(obj)
        } else {
          if (list[i].segmentCode === list[i - 1].segmentCode) {
            newArr.push({ row: 0, col: 0 })
            const index = list.findIndex((item) => {
              return item.segmentCode === list[i - 1].segmentCode
            })
            newArr[index].row++
          } else {
            newArr.push({ row: 1, col: 1 })
          }
        }
      }
      return newArr
    },

    // 隐藏掉不需要的表头
    discountHeaderStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0 && columnIndex === 0) {
        this.$nextTick(() => {
          document.getElementsByClassName(column.id)[0].setAttribute('rowSpan', 3)
        })
        return 'text-align:center;background:rgba(55, 169, 231, 0.05);border-radius: 8px;border:none;'
      }
      if (rowIndex === 1 && (columnIndex == 0 || columnIndex == 1 || columnIndex == 2)) {
        return {
          display: 'none',
        }
      }
      return 'background:rgba(55, 169, 231, 0.05);border-radius: 8px;border:none;'
    },
    spanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 2 || columnIndex === 5 || columnIndex == 6) {
        const arr = this.getSpan(this.tableData)
        const row = arr[rowIndex].row
        const col = arr[rowIndex].col
        return {
          rowspan: row,
          colspan: col,
        }
      }
    },
    // 计算表格底部的合计栏目
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        // 其他数字列，累加显示
        const values = data.map((item) => Number(item[column.property]))
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            console.log(prev, curr)
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index]
        }
        // 第一列显示total
        if (index === 0) {
          sums[index] = this.$t('total')
          return
        }
        // 最后一列取总计时间
        if (index === 5) {
          sums[index] = data[0]?.totalQuestionCount
          return
        }
        // 最后一列取总计时间
        if (index === 6) {
          sums[index] = data[0]?.totalDuration
          return
        }
      })

      return sums
    },
  },
}
</script>

<style lang="scss" scoped>
.segment-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  .segment_img {
    width: 28px;
    height: 28px;
    margin-right: 5px;
  }
  .segment_img_listen {
    width: 34px;
    height: 34px;
    margin-right: 0px;
  }
  .segment-cell-text {
    display: flex;
    align-items: center;
  }
  .segment_img_time {
    width: 25px;
    height: 25px;
    margin-right: 5px;
  }
}
::v-deep .el-table__footer-wrapper .el-table__cell {
  background: rgba(55, 169, 231, 0.05);
  border-radius: 8px;
  border: none;
}
</style>
